<div class="wnl-header">
  <p>
    WNL: Regular rate, rhythm, SI S2, no edema, extremities warm with capillary refill less than 3
    seconds. Pulses strong. No chest pain or palpations. No cyanosis.
  </p>

  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
</div>

<div [formGroup]="formGroup()" class="form-container">
  <div class="heartTones">
    <h2>Heart Tones</h2>

    <assessment-row title="Pulse Pattern">
      <emr-checkbox [control]="formGroup().controls.pulsePattern" label="Irregular" />
    </assessment-row>
    <assessment-row title="Heart Tones">
      <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.heartTones" [options]="heartTonesOptions"
        [default]="heartTonesDefault" [(wnl)]="wnlManager.controlColl['heartTones'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" />
    </assessment-row>
    <assessment-row title="Rhythm">
      <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.rhythm" [options]="rhythmOptions"
        [default]="rhythmDefault" [(wnl)]="wnlManager.controlColl['rhythm'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" />
      @if (isOtherRhythm) {
      <emr-input type="text" label="Comments" [control]="formGroup().controls.rhythmOther" />
      }
    </assessment-row>
  </div>

  <div class="edema-container">
    <h2>Edema</h2>
    <div class="edema-checkboxes">
      <emr-checkbox [control]="formGroup().controls.jvd" label="Presence of JVD" />
      <emr-checkbox [control]="formGroup().controls.gnpe" label="Generalized Non-Pitting Edema" />
    </div>

    <h2>Pitting Edema</h2>
    <div class="pitting-edema">
      <emr-input type="select" [hasWNL]="true" label="Right Hand" [control]="formGroup().controls.rightHand"
        [options]="pittingEdemaOptions" [default]="pittingEdemaDefault"
        [(wnl)]="wnlManager.controlColl['rightHand'].wnl" (wnlChange)="wnlManager.updateAllWNL()"
        [bottomSpace]="true" />
      <emr-input type="select" [hasWNL]="true" label="Left Hand" [control]="formGroup().controls.leftHand"
        [options]="pittingEdemaOptions" [default]="pittingEdemaDefault" [(wnl)]="wnlManager.controlColl['leftHand'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      <emr-input type="select" [hasWNL]="true" label="Right Foot" [control]="formGroup().controls.rightFoot"
        [options]="pittingEdemaOptions" [default]="pittingEdemaDefault"
        [(wnl)]="wnlManager.controlColl['rightFoot'].wnl" (wnlChange)="wnlManager.updateAllWNL()"
        [bottomSpace]="true" />
      <emr-input type="select" [hasWNL]="true" label="Left Foot" [control]="formGroup().controls.leftFoot"
        [options]="pittingEdemaOptions" [default]="pittingEdemaDefault" [(wnl)]="wnlManager.controlColl['leftFoot'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
    </div>
  </div>

  <div class="other">
    <assessment-row title="Generalized Perfusion">
      <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.generalizedPerfusion"
        [options]="generalizedPerfusionOptions" [default]="generalizedPerfusionDefault"
        [(wnl)]="wnlManager.controlColl['generalizedPerfusion'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
    </assessment-row>
    <assessment-row title="Cap Refill">
      <emr-checkbox [control]="formGroup().controls.capRefill" label="> 3 seconds" />
    </assessment-row>

    <h2>Pulses</h2>
    <div class="pulses">
      <emr-input type="select" [hasWNL]="true" label="RUE" [control]="formGroup().controls.pulseRue"
        [options]="pulseOptions" [default]="pulseDefault" [(wnl)]="wnlManager.controlColl['rue'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      <emr-input type="select" [hasWNL]="true" label="LUE" [control]="formGroup().controls.pulseLue"
        [options]="pulseOptions" [default]="pulseDefault" [(wnl)]="wnlManager.controlColl['lue'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      <emr-input type="select" [hasWNL]="true" label="RLE" [control]="formGroup().controls.pulseRle"
        [options]="pulseOptions" [default]="pulseDefault" [(wnl)]="wnlManager.controlColl['rle'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
      <emr-input type="select" [hasWNL]="true" label="LLE" [control]="formGroup().controls.pulseLle"
        [options]="pulseOptions" [default]="pulseDefault" [(wnl)]="wnlManager.controlColl['lle'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
    </div>

    <assessment-row title="Cyanosis Noted">
      <emr-input type="text" [control]="formGroup().controls.cyanosisNoted" />
    </assessment-row>

    <assessment-row title="Pace Maker">
      <emr-checkbox [control]="formGroup().controls.pacemaker" label="Yes" />
    </assessment-row>
    @if (isPaceMaker) {
    <emr-input type="text" label="Comments" [control]="formGroup().controls.pacemakerComment" />
    }
  </div>
</div>